import React from "react";
import { useFormContext } from "../pages/context/Context";
import "./StepIndicator.css";

const steps = [
    { id: 1, label: "Phone" },
    { id: 2, label: "Student" },
    { id: 3, label: "Payment" },
    { id: 4, label: "Amount" },
    { id: 5, label: "Pay" },
];

const StepIndicator = () => {
    const {
        phone,
        phoneData,
        selectedStudentData,
        studentData,
        paymentComp,
        selectedPaymentOption,
        amountComp,
        makePaymentComp,
    } = useFormContext();

    // Determine current step based on context state
    const getCurrentStep = () => {
        if (makePaymentComp) return 5;
        if (amountComp && selectedPaymentOption) return 4;
        if (paymentComp || selectedStudentData?.student_name || studentData?.length > 0) return 3;
        if (phoneData?.length > 0 || phone?.length === 10) return 2;
        return 1;
    };

    const currentStep = getCurrentStep();

    return (
        <div className="step-indicator">
            {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                    <div
                        className={`step ${step.id < currentStep
                                ? "completed"
                                : step.id === currentStep
                                    ? "active"
                                    : ""
                            }`}
                    >
                        <div className="step-circle">
                            {step.id < currentStep ? (
                                <span className="checkmark">✓</span>
                            ) : (
                                step.id
                            )}
                        </div>
                        <span className="step-label">{step.label}</span>
                    </div>
                    {index < steps.length - 1 && (
                        <div
                            className={`step-line ${step.id < currentStep ? "completed" : ""}`}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default StepIndicator;
